import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import PatternMatch from "@/pages/PatternMatch";
import Predictions from "@/pages/Predictions";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Auth pages — full screen, no sidebar */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />

            {/* Main app — with sidebar layout */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pattern-match" element={<PatternMatch />} />
              <Route path="predictions" element={<Predictions />} />

              {/* Legacy redirects */}
              <Route path="stocks" element={<Navigate to="/" replace />} />
              <Route path="correlation" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" />
      <div className="noise-overlay" />
    </div>
  );
}

export default App;
